import { render, staticRenderFns } from "./ProductReview.vue?vue&type=template&id=675d15dc"
import script from "./ProductReview.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductReview.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports